import IPhone from "@/module/main/dto/financing-v3/IPhone";

export class Phone implements IPhone
{
    constructor(public value: string)
    {
    }
}
